import styled from '@emotion/styled';
import Image from 'next/image';
import { shouldForwardProps } from '../../utils';

const PlayButtonWrapper = styled('div', shouldForwardProps)`
    position: relative;
`;

const PlayButtonArrow = styled(Image)`
    position: absolute;
    left: 0px;
    height: 100%;
    width: 100%;
`;

export { PlayButtonWrapper, PlayButtonArrow };
